const doc = [({"ja":({"adminConstantPromotionStayType":({"stay":"宿泊プランのみ対象", "oneDayTrip":"日帰りプランのみ対象", "allTypes":"宿泊と日帰りプランが対象"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;